import React, { useContext, useEffect, useRef, useState } from "react";
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Calendar } from 'primereact/calendar';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { UnitFieldSymbols } from '../components/input/fields/input-with-symbols';
import { Checkbox } from 'primereact/checkbox';
import { DataContext } from "../App";
import { useNavigate } from 'react-router-dom';
import { NavLink } from "react-router-dom";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div>
                    {children}
                </div>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

const BookingEngine = (props) => {

    const context = useContext(DataContext)
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [valueSearch, setValueSearch] = useState(0);
    const [destination, setDestination] = useState();
    const [experience, setExperience] = useState();
    const [experienceDate, setExperienceDate] = useState();
    const [experienceGuests, setExperienceGuests] = useState();
    const [isValidLinkExperience, setIsValidExperience] = useState(false);

    const laptop = window.matchMedia("screen and (min-width: 1024px) and (max-width: 1399px)").matches;
    const [dates, setDates] = useState();
    const [bathrooms, setBathrooms] = useState(0);
    const [bedrooms, setBedrooms] = useState(0);
    const [guests, setGuests] = useState(0);

    const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);

    const [checkboxes, setCheckboxes] = useState({
        weddingVenue: false,
        seaView: false,
        pool: false,
        walkToVillage: false,
        jacuzzi: false,
        heatedPool: false,
        hotTub: false,
        walkToBeach: false,
    });

    const areaOptions = context.properties && context.properties.filter(x => x.status === "active").reduce((acc, property) => {
        if (!acc.some(option => option.value === property.address.area)) {
            acc.push({ value: property.address.area, label: property.address.area });
        }
        return acc;
    }, []);

    const experienceOptions = context.properties && context.experiences.filter(x => x.status === "active").map((experience) => {
        return { value: `experiences/${experience.category}/${experience.seoInformation.linkUrl}`, label: experience.title };
    }, []);

    const handleCheckboxChange = (e) => {
        setCheckboxes({
            ...checkboxes,
            [e.target.name]: e.checked,
        });
    };

    const handleChangeSearch = (event, newValue) => {
        setValueSearch(newValue);
    };

    const toggleAdvancedSearch = () => {
        setShowAdvancedSearch(!showAdvancedSearch);
    };

    const addDays = (date, days) => {
        const newDate = new Date(date);
        newDate.setDate(newDate.getDate() + days);
        return newDate;
    };

    useEffect(() => {
        if (experienceGuests && experienceDate && experience) {
            setIsValidExperience(true);
        } else {
            setIsValidExperience(false);
        }
    }, [experienceGuests, experienceDate, experience]);

    useEffect(() => {
    }, [isValidLinkExperience]);


    return (
        <section className="background-white text-black d-flex flex-column negative-margin-inputs booking-engine-home">
            <div className="d-flex justify-content-center">
                <Tabs
                    value={valueSearch}
                    onChange={handleChangeSearch}
                    indicatorColor="secondary"
                    textColor="inherit"
                    variant="scrollable"
                    aria-label="tab"
                    className="lineTabList p-0 pt-2 mb-5"
                >
                    <Tab label={t('Property')} className="label-tab-search me-3" />
                    <Tab label={t('Experiences')} className="label-tab-search" />
                </Tabs>
            </div>

            <TabPanel className="effectSlowly" value={valueSearch} index={0}>
                <div className="d-flex w-100 flex-column flex-lg-row">
                    <div className="row w-100">
                        <div className={`col-lg-5 col-xl-4 col-md-6 col-12 select-no-outline d-flex justify-content-center flex-column padding-select-home ${laptop ? 'pr-6' : ''}`}>
                            <label className="mb-2 font-medium text-uppercase">{t('Destination')}</label>
                            <Select
                                className={`custom-select mb-4 mb-lg-0 ${laptop ? '' : 'w-75'}`}
                                options={areaOptions}
                                value={areaOptions && destination ? areaOptions.find((x) => x.value === destination) : null}
                                onChange={(e) => setDestination(e.value)}
                                placeholder={t('SearchDestination')}
                                theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        neutral0: 'white',
                                        primary25: '#333',
                                        primary: '#fff',
                                    },
                                })}
                            />
                        </div>
                        <div className={`col-lg-5 col-xl-4 col-md-6 col-12 select-no-outline d-flex justify-content-center flex-column px-6`}>
                            <label className="mb-2 font-medium text-uppercase">{t('Date')}</label>
                            <Calendar
                                value={dates}
                                onChange={(e) => setDates(e.value)}
                                inputClassName="w-full my-0 custom-select-booking-engine pb-0 input-calendar-custom"
                                className={`custom-select mb-4 mb-lg-0 my-2 ${laptop ? '' : 'w-75'}`}
                                placeholder={t('SelectCheckInCheckOutDate')}
                                dateFormat="dd/mm/yy"
                                selectionMode="range"
                                hideOnRangeSelection
                                minDate={addDays(new Date(Date.now()), 1)}
                                readOnlyInput={true}
                            />
                        </div>
                        <div className={`col-lg-${laptop ? '2 px-0' : '4'} custom-guests px-xl-5 col-md-6 col-12 select-no-outline d-flex justify-content-center flex-column`}>
                            <UnitFieldSymbols
                                key={guests}
                                label={t('Guests')}
                                labelClassName="text-uppercase"
                                value={guests}
                                className={`border-none ${laptop ? 'w-100' : 'w-75-custom'}`}
                                onChange={(e) => setGuests(e.target.value)}
                            ></UnitFieldSymbols>
                        </div>

                        <div className={`col-12 background-white d-flex justify-content-center flex-column pt-5 ${laptop ? 'pe-0' : ''}`}>
                            <button
                                className="background-white text-black pt-4 mt-2 pe-1 w-full text-left border-none border-1 border-black border-bottom px-0"
                                onClick={toggleAdvancedSearch}
                            >
                                <div className="d-flex justify-content-between border-bottom border-black">
                                    <div className="mb-3 ">{t('AdvancedSearch').toUpperCase()}</div>
                                    <div>
                                        <FontAwesomeIcon icon={showAdvancedSearch ? faChevronUp : faChevronDown} className="ms-2 fs-15" />
                                    </div>
                                </div>
                            </button>
                            {showAdvancedSearch && (
                                <div className="advanced-search mt-4">
                                    <div className="d-flex flex-wrap">
                                        <div className="col-xxl-2 col-md-6 col-12 d-flex flex-column border-none">
                                            <UnitFieldSymbols
                                                key={bathrooms}
                                                label={t('Bathrooms')}
                                                labelClassName={"text-uppercase"}
                                                value={bathrooms}
                                                className={`border-none ${props.isMobile ? "w-75-custom" : "w-75"}`}
                                                onChange={(e) => setBathrooms(e.target.value)}
                                            ></UnitFieldSymbols>
                                        </div>
                                        <div className="col-xxl-2 col-md-6 col-12 d-flex flex-column border-none">
                                            <UnitFieldSymbols
                                                key={bedrooms}
                                                label={t('Bedrooms')}
                                                labelClassName={`text-uppercase ${props.isMobile ? "mt-4" : ""}`}
                                                value={bedrooms}
                                                className={`border-none ${props.isMobile ? "w-75-custom mb-4" : "w-75"}`}
                                                onChange={(e) => setBedrooms(e.target.value)}
                                            ></UnitFieldSymbols>
                                        </div>
                                        <div className="col-xxl-8 col-12 advanced-search-check d-flex flex-wrap mt-4">
                                            <div className="col-xl-3 col-md-6 col-12">
                                                <label className="custom-checkbox-label text-uppercase ">
                                                    <Checkbox
                                                        name="weddingVenue"
                                                        checked={checkboxes.weddingVenue}
                                                        onChange={handleCheckboxChange}
                                                        className={"checkbox-custom me-2"}
                                                    />
                                                    {t('WeddingVenue')}
                                                </label>
                                            </div>
                                            <div className="col-xl-3 col-md-6 col-12">
                                                <label className="custom-checkbox-label text-uppercase">
                                                    <Checkbox
                                                        name="seaView"
                                                        checked={checkboxes.seaView}
                                                        onChange={handleCheckboxChange}
                                                        className={"checkbox-custom me-2"}
                                                    />
                                                    {t('SeaView')}
                                                </label>
                                            </div>
                                            <div className="col-xl-3 col-md-6 col-12">
                                                <label className="custom-checkbox-label text-uppercase">
                                                    <Checkbox
                                                        name="privatePool"
                                                        checked={checkboxes.privatePool}
                                                        onChange={handleCheckboxChange}
                                                        className={"checkbox-custom me-2"}
                                                    />
                                                    {t('Pool')}
                                                </label>
                                            </div>
                                            <div className="col-xl-3 col-md-6 col-12">
                                                <label className="custom-checkbox-label text-uppercase">
                                                    <Checkbox
                                                        name="walkToVillage"
                                                        checked={checkboxes.walkToVillage}
                                                        onChange={handleCheckboxChange}
                                                        className={"checkbox-custom me-2"}
                                                    />
                                                    {t('WalkToVillage')}
                                                </label>
                                            </div>
                                            <div className="col-xl-3 col-md-6 col-12">
                                                <label className="custom-checkbox-label text-uppercase">
                                                    <Checkbox
                                                        name="jacuzzi"
                                                        checked={checkboxes.jacuzzi}
                                                        onChange={handleCheckboxChange}
                                                        className={"checkbox-custom me-2"}
                                                    />
                                                    {t('Jacuzzi')}
                                                </label>
                                            </div>
                                            <div className="col-xl-3 col-md-6 col-12">
                                                <label className="custom-checkbox-label text-uppercase">
                                                    <Checkbox
                                                        name="heatedPool"
                                                        checked={checkboxes.heatedPool}
                                                        onChange={handleCheckboxChange}
                                                        className={"checkbox-custom me-2"}
                                                    />
                                                    {t('HeatedPool')}
                                                </label>
                                            </div>
                                            <div className="col-xl-3 col-md-6 col-12">
                                                <label className="custom-checkbox-label text-uppercase">
                                                    <Checkbox
                                                        name="hotTub"
                                                        checked={checkboxes.hotTub}
                                                        onChange={handleCheckboxChange}
                                                        className={"checkbox-custom me-2"}
                                                    />
                                                    {t('HotTub')}
                                                </label>
                                            </div>
                                            <div className="col-xl-3 col-md-6 col-12">
                                                <label className="custom-checkbox-label text-uppercase">
                                                    <Checkbox
                                                        name="walkToBeach"
                                                        checked={checkboxes.walkToBeach}
                                                        onChange={handleCheckboxChange}
                                                        className={"checkbox-custom me-2"}
                                                    />
                                                    {t('WalkToBeach')}
                                                </label>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="d-flex justify-content-center h-25 ps-lg-5">
                        <NavLink
                            to={
                                dates && dates.length === 2 && guests
                                    ? `${process.env.REACT_APP_SITE_URL}property-collection`
                                    : ""
                            }
                            state={
                                dates && dates.length === 2 && guests
                                    ? {
                                        searchedDestination: destination,
                                        searchedCheckIn: dates[0],
                                        searchedCheckOut: dates[1],
                                        searchedGuests: guests,
                                        searchedBathrooms: bathrooms,
                                        searchedBedrooms: bedrooms,
                                        searchedCheckboxes: checkboxes,
                                    }
                                    : undefined
                            }
                            className={`ms-lg-5 bg-transparent text-decoration-none text-black pt-4 mt-3 text-center w-100 text-nowrap border-none text-uppercase ${!(dates && dates.length === 2 && guests) ? "inactive-element" : "lineEffectBlack"
                                }`}
                        >
                            {t("SearchVilla")}
                        </NavLink>
                    </div>
                </div>
            </TabPanel>
            <TabPanel value={valueSearch} index={1}>
                <div className="d-flex w-100 flex-column flex-lg-row">
                    <div className="row w-100">
                        <div className={`col-lg-5 col-xl-4 col-md-6 col-12 select-no-outline d-flex justify-content-center flex-column padding-select-home ${laptop ? 'pr-6' : ''}`}>
                            <label className="mb-2 font-medium text-uppercase">{t('Experiences')}</label>
                            <Select
                                className={`custom-select mb-4 mb-lg-0 ${laptop ? '' : 'w-75'}`}
                                options={experienceOptions}
                                value={experienceOptions && experience ? experienceOptions.find((x) => x.value === experience) : null}
                                onChange={(e) => setExperience(e.value)}
                                placeholder={t('SearchExperience')}
                                theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        neutral0: 'white',
                                        primary25: '#333',
                                        primary: '#fff',
                                    },
                                })}
                            />
                        </div>
                        <div className={`col-lg-5 col-xl-4 col-md-6 col-12 select-no-outline d-flex justify-content-center flex-column px-6`}>
                            <label className="mb-2 font-medium text-uppercase">{t('Date')}</label>
                            <Calendar
                                value={experienceDate}
                                onChange={(e) => setExperienceDate(e.value)}
                                inputClassName="w-full my-0 custom-select-booking-engine pb-0 input-calendar-custom"
                                className={`custom-select mb-4 mb-lg-0 my-2 ${laptop ? '' : 'w-75'}`}
                                placeholder={t('SelectDate')}
                                dateFormat="dd/mm/yy"
                                selectionMode="range"
                                hideOnRangeSelection
                                minDate={addDays(new Date(Date.now()), 1)}
                                readOnlyInput={true}
                            />
                        </div>
                        <div className={`col-lg-${laptop ? '2 px-0' : '4'} custom-guests px-xl-5 col-md-6 col-12 select-no-outline d-flex justify-content-center flex-column`}>
                            <UnitFieldSymbols
                                key={experienceGuests}
                                label={t('Guests')}
                                labelClassName={"text-uppercase"}
                                value={experienceGuests}
                                className={`border-none ${laptop ? 'w-100' : 'w-75'}`}
                                onChange={(e) => setExperienceGuests(e.target.value)}
                            ></UnitFieldSymbols>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center h-25 ps-lg-5">
                        <NavLink
                            to={isValidLinkExperience && experience ? experience : ""}
                            className={`ms-lg-5 bg-transparent text-decoration-none text-black pt-4 mt-3 text-center w-100 text-nowrap border-none text-uppercase ${isValidLinkExperience ? "cursor-pointer lineEffectBlack" : "inactive-element"}`}
                        >
                            {t("ViewExclusiveOffers")}
                        </NavLink>
                    </div>
                </div>
            </TabPanel>

        </section>
    );
};

export default BookingEngine;
